import SlideoutMenu from '@orn/shared-web/components/SlideoutMenu';
import { ClockFastForwardIcon } from '@orn/shared-web/icons';

import { getFrequencyLabel } from '../../../utils/recurring';

import type { RecurringTransactionFrequency } from '../../../__generated__/globalTypes';

interface IRecurringFrequencyRowProps {
  frequency: RecurringTransactionFrequency | null | undefined;
}

const RecurringFrequencyRow = ({ frequency }: IRecurringFrequencyRowProps) => {
  if (!frequency) {
    return null;
  }

  return (
    <SlideoutMenu.Row icon={<ClockFastForwardIcon className="size-4.5 shrink-0" />} title="Frequency">
      <div className="text-primary text-md font-medium">{getFrequencyLabel(frequency)}</div>
    </SlideoutMenu.Row>
  );
};

export default RecurringFrequencyRow;
